import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import React, { useContext, useEffect } from 'react';
import { FormFieldProps } from 'lib/forms/FormFieldProps';
import { fieldFactoryComponent } from 'temp/formFactory';
import classNames from 'classnames';
import { FormsContext } from 'lib/forms/FormContext';
import { BodyCopy } from 'src/helpers/BodyCopy';
import { FormikValues, useFormikContext } from 'formik';
import { FormsConstants } from 'lib/constants/forms-constants';

export type PageProps = Feature.EnterpriseWeb.Enterprise.Forms.Structure.Page &
  FormFieldProps & {
    classes: string;
  };

const Page = (props: PageProps) => {
  const { isErrorOnSubmit } = useContext(FormsContext);
  const { formProps } = useContext(FormsContext);
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const paddingGap =
    formProps.fields?.inputPadding?.fields?.Value?.value === 'reduced'
      ? 'gap-x-s gap-y-xxs'
      : 'gap-y-m gap-x-s';

  useEffect(() => {
    function handleOpenFormEvent(e: CustomEvent) {
      if (!!e.detail?.form) {
        Object.keys(e.detail.form).forEach((key) => {
          if (key in values) {
            // only set field value if the field exists
            setFieldValue(key, e.detail.form[key]);
          }
        });
      }
    }
    document.addEventListener(FormsConstants.Enterprise.openFormEvent, handleOpenFormEvent);
    return () => {
      document.removeEventListener(FormsConstants.Enterprise.openFormEvent, handleOpenFormEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!props.fields) {
    return <></>;
  }

  return (
    <div className={classNames(props.classes, 'grid grid-cols-12', paddingGap)}>
      {props.fields?.children.map((child: FormFieldProps) => fieldFactoryComponent(child))}
      {isErrorOnSubmit && (
        <BodyCopy
          fields={{ body: { value: isErrorOnSubmit } }}
          classes="relative mb-s col-span-12 text-[#F14343] text-small"
        />
      )}
    </div>
  );
};

export default Page;
